import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { mockupApiRef, MockupClient } from './api';

import { rootRouteRef, managementRouteRef, previewRouteRef } from './routes';

export const mockupPlugin = createPlugin({
  id: 'mockup',
  routes: {
    root: rootRouteRef,
    management: managementRouteRef,
    preview: previewRouteRef,
  },
  apis: [
    createApiFactory({
      api: mockupApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new MockupClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const MockupPage = mockupPlugin.provide(
  createRoutableExtension({
    name: 'MockupPage',
    component: () =>
      import('./components/MockupPage').then(m => m.MockupPage),
    mountPoint: rootRouteRef,
  }),
);

export const MockupManagementPage = mockupPlugin.provide(
  createRoutableExtension({
    name: 'MockupManagementPage',
    component: () =>
      import('./components/MockupManagementPage').then(m => m.MockupManagementPage),
    mountPoint: managementRouteRef,
  }),
);

export const MockupPreviewPage = mockupPlugin.provide(
  createRoutableExtension({
    name: 'MockupPreviewPage',
    component: () =>
      import('./components/MockupPreviewPage').then(m => m.MockupPreviewPage),
    mountPoint: previewRouteRef,
  }),
);
